<template>
  <div id="catalog__mob_header_id" class="flex md:items-center justify-between">
    <div class="flex flex-wrap items-center gap-[8px]">
      <button class="md:hidden hover:border-lime-green w-[153px] flex items-center justify-between toggle border border-[#C7C7C7] p-[16px] rounded-[8px] text-[16px] font-light"
              type="button"
              @click="openMobileFilters()">
        {{ in18['page_filters'] }}
      </button>
      <div class="dropdown">
        <button aria-expanded="false" aria-haspopup="true"
                class="hover:border-lime-green w-[153px] flex items-center justify-between toggle border border-[#C7C7C7] p-[16px] rounded-[8px] text-[16px] font-light"
                data-bs-toggle="dropdown"
                type="button">
          {{ in18['page_per_page'] }}
        </button>
        <ul class="dropdown-menu  dropdown-menu-end">
          <li>
            <a class="dropdown-menu__link" href="javascript:void(0)"
               title="16"
               @click="changeFilter('per_page', '16')">
              16
            </a>
          </li>
          <li>
            <a class="dropdown-menu__link"
               href="javascript:void(0)"
               title="32"
               @click="changeFilter('per_page', '32')">
              32
            </a>
          </li>
          <li>
            <a class="dropdown-menu__link"
               href="javascript:void(0)"
               title="48"
               @click="changeFilter('per_page', '48')">
              48
            </a>
          </li>
          <li>
            <a class="dropdown-menu__link"
               href="javascript:void(0)"
               title="96"
               @click="changeFilter('per_page', '96')">
              96
            </a>
          </li>
        </ul>
      </div>
      <div class="dropdown">
        <button aria-expanded="false" aria-haspopup="true"
                class="hover:border-lime-green w-[153px] flex items-center justify-between toggle border border-[#C7C7C7] p-[16px] rounded-[8px] text-[16px] font-light "
                data-bs-toggle="dropdown"
                type="button">
          {{ in18['page_sort_by'] }}
        </button>
        <ul class="dropdown-menu  dropdown-menu-end ">
          <li>
            <a :title="in18['page_largest_number']" class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'quantity:desc')">
              {{ in18['page_largest_number'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_smallest_quantity']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'quantity:asc')">
              {{ in18['page_smallest_quantity'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_newest_first']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'created_at:desc')">
              {{ in18['page_newest_first'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_oldest_first']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'created_at:asc')">
              {{ in18['page_oldest_first'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_by_name_a_z']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'code:desc')">
              {{ in18['page_by_name_a_z'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_by_name_z_a']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'code:asc')">
              {{ in18['page_by_name_z_a'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_lowest_prices_first']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'price_with_tax:asc')">
              {{ in18['page_lowest_prices_first'] }}
            </a>
          </li>
          <li>
            <a :title="in18['page_highest_prices_first']"
               class="dropdown-menu__link"
               href="javascript:void(0)"
               @click="changeFilter('sort', 'price_with_tax:desc')">
              {{ in18['page_highest_prices_first'] }}
            </a>
          </li>
        </ul>
      </div>
    </div>

    <ul class="category-sort__list  category-sort__list--grid ml-2 !items-start">
      <li>
        <button :class="{ 'active': display === 'grid' }" class="category-sort__list-btn  category-sort__list-btn--grid"
                type="button"
                @click="setDisplay('grid')">
        </button>
      </li>
      <li>
        <button :class="{ 'active': display === 'row' }" class="category-sort__list-btn  category-sort__list-btn--list"
                type="button"
                @click="setDisplay('row')">
        </button>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name:    "catalogSort",
  props:   {
    in18:    Object,
    display: String,
  },
  emits:   [
    'changeFilter',
    'displayChanged'
  ],
  methods: {
    changeFilter(prop, value) {
      this.$emit('changeFilter', prop, value);
    },
    setDisplay(display) {
      this.$emit('displayChanged', display);
    },
    openMobileFilters() {
      // console.log('opening')
      this.$store.dispatch('setFilters', true)
    }
  },
};
</script>


<style>
.toggle:after {
  content: "";
  display: block;
  width: 1.6rem;
  height: 1.6rem;
  margin-left: 0.6rem;
  background-image: url("/shop/images/arrow-down.svg");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}
</style>